<template>
  <div id="twoPage">
    <!-- 持仓汇总查询 -->
    <div class="transcc_new_NewFooter_tabs_mid">
      <div class="transcc_search">
        <!-- <div class="itemSearch">
          <span class="title">商品代码</span>
          <el-select
            v-model="search.commodityCode"
            class="searchSelect"
            size="small"
            filterable
            placeholder="显示全部"
            @change="changeCode"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.commodityCode"
              :value="item.commodityCode"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch">
          <span class="title">商品名称</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.symbol"
            popper-class="ccStyle"
            class="searchSelect"
            size="small"
            placeholder="显示全部"
            @change="changeSymbol"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbol"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">买 | 卖</span>
          <el-select
            :popper-append-to-body="true"
            v-model="search.bsFlag"
            class="searchSelect"
            popper-class="ccStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch actionSearch">
          <el-button
            plain
            class="errorBtn"
            size="small"
            style="width: 74px;height: 24px;color:#0486fe;background: #D94066;font-size:14px;"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="greenBtn"
            size="small"
            style="width: 74px;height: 24px;color:#fff;background: #41B37D;font-size:14px;"
            @click="restData"
          >重置</el-button>
        </div>
      </div>
    </div>
    <div class="transcc_new_NewFooter_tabs_tabBox">
      <!-- <div class="transcc_new_NewFooter_tabs_tabBox_head"> -->
      <el-table
        ref="tableData"
        :data="tableData"
        height="256"
        class="table_style"
        style="width: 100%"
        :cell-class-name="directionClass"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange"
        @row-dblclick="openTransDialog"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
          min-width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="60"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买 | 卖"
          sortable="custom"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="initAvgPrice"
          label="订立均价"
          sortable="custom"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <!-- :class="scope.row.bsFlag=='买入'?'red-row':'green-row'" class="fw" -->
            <span> {{ scope.row.initAvgPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="存货数量"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="frozeQuantity"
          label="委托冻结数量"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.frozeQuantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="scQuantity"
          label="锁仓数量"
          min-width="80"
        >
          <template slot-scope="scope">
            <span class="yellow-row  fr"> {{ scope.row.optimizeQuantity }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶数量"
          min-width="80"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶冻结数量"
          min-width="120"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="holdMargin"
          label="订货金额"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.holdMargin }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalPrice"
          label="存货金额"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.totalPrice?scope.row.totalPrice.toFixed(2):0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="holdPl"
          label="货值变化"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.textColor"> {{ scope.row.holdPl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="currentHoldPl"
          label="实时货值变化"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="scope.row.textSColor"> {{ scope.row.currentHoldPl }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="index" min-width="70" label="转让" align="center">
          <template slot-scope="scope">
            <span
              v-if="(Number(scope.row.quantity) - Number(scope.row.frozeQuantity) - Number(scope.row.optimizeQuantity))>0"
              class="spotS"
              @click.stop="openTransDialog(scope.row)"
            > 转让
            <!-- {{ scope.row.bsFlag=='卖出'?'买入转让':'卖出转让' }} -->
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="date"
          label="实时货值变化"
          width="140"
        >
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24">
          <el-pagination
            class="pagination_style"
            popper-class="dark_popStyle"
            :current-page="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <transHold ref="transHold" type="2" @reLoad="showData" />
  </div>
</template>
<script>
/*global http protocol util hqWs hqProtocol*/
import transHold from './transHold.vue'
import {
  mapGetters
} from 'vuex'
export default {
  components: {
    transHold
  },
  data() {
    return {
      bsFlagOptions: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 'B',
          label: '买入'
        },
        {
          value: 'S',
          label: '卖出'
        }
      ],
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 6,
        currentPage: 1
      },
      search: {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        floatPl: null,
        commodityId: null
      },
      timer: null,
      HoldFrontSum: {
        'totalQuantity': 0,
        'frozeQuantity': 0,
        'holdMargin': 0,
        'totalPrice': 0
      },
      dataArr: '',
      dialogVisible: false,
      isNetWrong: false,
      holdPlSum: 0, // 货值变化合计
      counter: 0 // 定时器计数器
    }
  },
  computed: {
    ...mapGetters(['h_holdTime', 'sessionInfoGetter', 'marketStatusInNewTopline', 'marketDetails', 'h_sumClosePl', 'marketStatusGetter', 'queryTradeAuthArrGetter']),
    commodityOptions() {
      const commodityList = structuredClone(this.$store.state.hqData.marketDetails)
      commodityList.unshift({commodityId: null,symbol: '全部'})
      return commodityList
    }

  },
  watch: {
    h_holdTime(val, oldVal) {
      this.recursionShowData()
    },
    marketDetails: {
      handler(val, oldVal) {
        const arr = JSON.parse(this.dataArr)
        this.judgeDataType(arr)
      },
      deep: true
    },
    marketStatusGetter(val, oldVal) {
      if (val.status != oldVal.status) {
        this.showData()
      }
    }
  },
  updated() {
      this.$nextTick(() => {
          this.$refs.tableData.doLayout()
      })
  },
  mounted() {
    this.recursionShowData()
    const that = this
    this.timer = setInterval(() => {
      if (that.counter) {
        that.counter = 0
        this.showData()
      }
    }, window.g.Risk_Right_Time ? window.g.Risk_Right_Time : 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    coinSmallDigital(s) {
      const minPriceChange = s.minPriceChange // 最小数量变动单位
      const minAmountChange = s.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        // //symbolId: this.item.symbolId,
        // numStr:/^(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$') // 数量
      }
    },
    // 点击买入卖出转让
    openTransDialog(obj) {
      hqProtocol.param_toporder.symbol = obj.commodityId
      hqWs.send(hqProtocol.param_toporder)
      this.$refs.transHold.showDialog(obj)
    },
    changeCode(code) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.search.commodityCode = element.commodityCode
          this.search.symbol = element.symbol
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    changeSymbol(symbol) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
         if(element.symbol == '全部'){
           this.search.commodityId = null
           this.search.symbol = element.symbol
           this.search.commodityCode = null
           return
        }else if (element.symbol === symbol) {
          this.search.symbol = element.symbol
          this.search.commodityCode = element.commodityCode
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    restData() {
      this.search = {
        commodityCode: null,
        symbol: '全部',
        bsFlag: null,
        floatPl: null,
        commodityId: null
      }
      protocol.queryUserPositionSummariesNew.data.commodityId = null
      this.pageData.currentPage = 1
      this.showData()
    },
    searchData() {
      this.pageData.currentPage = 1
      this.showData()
    },

    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      protocol.queryUserPositionSummariesNew.data.page =
          this.pageData.currentPage - 1
      protocol.queryUserPositionSummariesNew.data.size =
          '' + this.pageData.pageSize
      protocol.queryUserPositionSummariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserPositionSummariesNew.data.commodityId = this.search.commodityId
      protocol.queryUserPositionSummariesNew.data.bsFlag = this.search.bsFlag
      http.gPost(protocol.queryUserPositionSummariesNew).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.dataArr = JSON.stringify(response.data.value.content)
            this.judgeDataType(arr)
            this.HoldFrontSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
              'totalQuantity': 0,
              'frozeQuantity': 0,
              'holdMargin': 0,
              'totalPrice': 0
            }
          }
        }
      }).catch((e) => {
      })

      const parms = JSON.parse(JSON.stringify(protocol.queryUserPositionSummariesNew))
      parms.data.page = 0
      parms.data.size = 99999
      http.gPost(parms).then(response => {
        that.holdPlSum = 0
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            const that = this
            this.each(response.data.value.content, function(arrIndex) {
              that.commodityOptions.forEach(value => {
                if (value.symbolId == arrIndex.commodityId) {
                  var MarketPrice = value.averagePrice.toFixed(that.coinSmallDigital(value).coinDigitalNum)
                  MarketPrice = MarketPrice == 0 ? value.close.toFixed(that.coinSmallDigital(value).coinDigitalNum) : MarketPrice // 行情均价
                  arrIndex.holdPl = arrIndex.bsFlag === 'B'
                    ? (util.floatSub(MarketPrice, arrIndex.initAvgPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
                    : (util.floatSub(arrIndex.initAvgPrice, MarketPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
                  return
                }
              })
              that.holdPlSum = util.floatAdd(that.holdPlSum, arrIndex.holdPl)
            })
          }
        }
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.textColor = ''
        arrIndex.textSColor = ''
        that.commodityOptions.forEach(value => {
          if (value.symbolId == arrIndex.commodityId) {
            var MarketPrice = value.averagePrice.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            if (that.marketStatusGetter.status === 'E' || that.marketStatusGetter.status === 'C') {
              arrIndex.currentHoldPl = arrIndex.hholdPl.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            } else {
              // arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
              //   ? (util.floatSub(value.close, arrIndex.avgPrice) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              //   : (util.floatSub(arrIndex.avgPrice, value.close) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              // totalPrice 总价
              arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
                ? (util.floatSub(value.close * arrIndex.quantity, arrIndex.totalPrice) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
                : (util.floatSub(arrIndex.totalPrice, value.close * arrIndex.quantity) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            }
            MarketPrice = MarketPrice == 0 ? value.close.toFixed(that.coinSmallDigital(value).coinDigitalNum) : MarketPrice // 行情均价
            arrIndex.holdPl = arrIndex.bsFlag === 'B'
              ? (util.floatSub(MarketPrice, arrIndex.initAvgPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              : (util.floatSub(arrIndex.initAvgPrice, MarketPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            return
          }
        })
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.holdPl))
        arrIndex.textSColor = that.threeTxtColor(Number(arrIndex.currentHoldPl))
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserPositionSummariesNew.data.sort = [{
          'direction': 'ASC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserPositionSummariesNew.data.sort = [{
          'direction': 'DESC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else {
        protocol.queryUserPositionSummariesNew.data.sort = [{
          'direction': 'DESC',
          'property': 'holdId'
        }]
      }
      protocol.queryUserPositionSummariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserPositionSummariesNew.data.bsFlag = this.search.bsFlag
      protocol.queryUserPositionSummariesNew.data.commodityId = this.search.commodityId
      if (column.column) {
        http.gPost(protocol.queryUserPositionSummariesNew).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.HoldFrontSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
                'totalQuantity': 0,
                'frozeQuantity': 0,
                'holdMargin': 0,
                'totalPrice': 0
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserPositionSummariesNew.data.sort[0].property = str)
    },
    // 递归订单展示
    recursionShowData() {
      protocol.queryUserPositionSummariesNew.data.holdNo = null
      this.showData()
      // this.timer = setTimeout(() => {
      //   this.recursionShowData()
      // }, window.g.APP_RUNLOOP_TIME ? window.g.APP_RUNLOOP_TIME : 3000)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 1: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = '共' + that.pageData.total + '条'
          return
        }

        if (index === 3) { // 20230808 更改需求 原存货数量合计 改为 总买入存货数量-总卖出存货数量
          sums[index] = that.HoldFrontSum.totalQuantity
          return
        }
        if (index === 4) { // 委托冻结数量
          sums[index] = that.HoldFrontSum.frozeQuantity
          return
        }
        if (index === 5) { // 订货金额
          sums[index] = that.HoldFrontSum.holdMargin.toFixed(2)
          return
        }
        if (index === 6) { // 存货金额
          sums[index] = that.HoldFrontSum.totalPrice.toFixed(2)
          return
        }
        if (index === 7) { // 货值变化
          sums[index] = that.holdPlSum
          return
        }

        sums[index] = ''
      })
      return sums
    }
  }

}
</script>
<style lang="scss" scoped>
/deep/ .el-table__footer-wrapper .el-table__footer{
    height: 36px !important;
}
/deep/ .el-table__row{
  height: 32px;
}
/deep/ .el-table td div{
  text-align: center;
  color: #dfdfdf;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
</style>
<style lang="scss" scoped>
//el-selecl Style
::v-deep .el-input--small .el-input__icon{
  line-height: 26px;
}
.el-select-dropdown__item.selected{
  color: #989898
}
</style>

<style lang="scss" scoped>
/deep/ .el-table table tr{
   background-color: #161719;
}
// #threePage{
//  width:calc(100% - 181px);
// }
.transcc_search{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3px 0;
  .itemSearch{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    .title{
      width:60px;
      font-size:14px;
      // margin:0 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
    }
    .searchSelect{
      width:158px;
    }
    .decTitle{
      width: 44px;
    }
  }
  // }
  //  /deep/.el-button{
  //    border:none;
  //  }

  // /deep/.el-button span{
  //   color:#fff;
  // }
   /deep/ .el-input.is-focus .el-input__inner{
         border-color: #fff !important;
  }
  /deep/  .el-input__inner{
         height: 26px !important;
        background-color: transparent;
        border-color: rgba($color: #fff, $alpha: 0.3);
      }
   /deep/.el-button{
     border:none;
     border-radius: 15px;
    padding: 5px 15px !important;
   }
  /deep/.el-button span {
    color: #fff;
  }
  .actionSearch{
    margin-left:10px;
  }

}
 .transcc_query_search {
        margin-top: 16px;
        .el-button{
          width:52px;
          height: 32px;
          background-color:transparent;
          border: 1px solid #363F66;
        }
  }
  .transcc_new_NewFooter_tabs_tabBox {
    width: 100%;
    .transcc_new_NewFooter_tabs_tabBox_head {
      width: 100%;
      display: flex;
      // justify-content: space-around;
      align-items: center;
      height: 60px;
      .tab_head_item {
        width: 130px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        height: 14px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.6);
        line-height: 14px;
      }
    }
    .borderline {
      width: 100%;
      height: 1px;
      background: linear-gradient(
        45deg,
        rgba(94, 101, 146, 0.4) 0%,
        #464c74 53%,
        rgba(48, 53, 89, 0.4) 100%
      );
    }
  }
  #transcc_new_NewFooter #twoPage .el-table__footer-wrapper td:nth-child(n + 7) .cell {
  color: #fff;
}
  #transcc_new_NewFooter #twoPage .el-table__footer-wrapper td:nth-child(11) .cell {
  color: #fff;
}
// #twoPage /deep/ .el-table__footer-wrapper td:nth-child(4) .cell{
//   text-align: right;
// }
</style>
<style  lang="scss">
  // .ccStyle .el-select-dropdown__list{
  //   // width: 156px !important;
  // }
  .ccStyle.el-select-dropdown{
  background-color: #010101 !important;
}
 .ccStyle .el-select-dropdown__item.hover{
  background-color: #2c2c2c !important;
}
</style>
